"use client";
import React, { useState, useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { GoArrowUp } from "react-icons/go";
import { FaSquareFacebook } from "react-icons/fa6";
import { IoLogoLinkedin } from "react-icons/io5";
import { RiInstagramFill } from "react-icons/ri";
import { FaArrowRight } from "react-icons/fa6";
import { toast } from "react-toastify";
import axios from "axios";
import { base_URL } from "../../config/config";
import LoginModal from "../LoginModal";
import {
	toggleSignUp,
	toggleLogin,
	toggleSocial,
	toggleAdditional,
	toggleCheckInbox,
	closeModals,
	toggleReset,
} from "../../store/features/modalSlice";
import { resetFormData } from "../../store/features/authSlice";
import ResetPassword from "../forget-password/ResetPassword";
import ResetMailSend from "../forget-password/ResetMailSent";
import ResetWorkMail from "../forget-password/ResetWorkMail";
import PasswordUpdated from "../forget-password/PasswordUpdated";
import SignUpModal from "../SignUpModal";
import AdditionalDetails from "../AdditionalDetails";
import SocialModal from "../SocialModal";
import CheckInboxModal from "../CheckInboxModal";
import { useDispatch, useSelector } from "react-redux";
import Modal from "../shared/Modal";

const Footer = ({ onScrollDownClick }) => {
	const navigate = useNavigate();
	const [email, setEmail] = useState("");
	const [showModal, setShowModal] = useState(false);
	const vendorId = localStorage.getItem("vendorId");
	const isLoggedIn = !!localStorage.getItem("accessToken");
	const dispatch = useDispatch();
	const location = useLocation();
	const [encryptedMail, setEncryptedMail] = useState("");

	const {
		showSignUp,
		showLogin,
		showReset,
		showSocial,
		resetWorkMail,
		showAdditional,
		showCheckInbox,
		resetMailSend,
		updatePassword,
	} = useSelector((state) => state.modal);

	const handleSubscribe = async () => {
		if (email.trim() === "") {
			toast.error("Please enter a valid email.");
			return;
		}
		// console.log(email);
		try {
			const response = await axios.post(`${base_URL}/api/newsletter`, {
				email,
			});
			// console.log(response);
			if (response.data.success) {
				toast.success("Subscribed successfully! Thank you for signing up.");
			}
		} catch (error) {
			toast.error("Something went wrong. Please try again later.");
		}

		// Clear the input field
		setEmail("");
	};

	useEffect(() => {
		const queryParams = new URLSearchParams(location.search);
		const emailParam = queryParams.get("email");

		// If email exists in the query, dispatch toggleReset to open the reset password modal
		if (emailParam) {
			const decryptMail = window.atob(emailParam);
			setEncryptedMail(decryptMail);
			dispatch(toggleReset());
		}
	}, [location, dispatch]);

	const handleClickUserLogin = () => {
		if (vendorId || isLoggedIn) {
			toast.error("You are already logged in.");
		} else {
			// dispatch(toggleLogin());
			navigate("/user-login");
		}
	};

	return (
		<div className="bg-[#222222] sm:p-16 p-4 py-20 ">
			<div className="text-white flex justify-between md:flex-row flex-col gap-10 items-center">
				<div>
					<h1 className="sm:text-3xl text-2xl mb-2">Newsletter Signup</h1>
					<p>Get the latest news and offers with our Registration</p>
				</div>
				<div className=" sm:pl-5 pl-2 sm:text-base text-xs flex lg:flex-1 lg:w-full md:w-[65%] w-full items-center justify-between bg-[#505050]">
					<input
						type="text"
						className=" bg-transparent lg:w-[35%] w-[50%] outline-none border-b pb-2 border-[#ababab] placeholder:text-gray-400"
						placeholder="yourname@email.com"
						value={email}
						onChange={(e) => setEmail(e.target.value)} // Update state when the user types
					/>
					<button
						onClick={handleSubscribe} // Handle subscribe click
						className="flex items-center gap-2 lg:w-[30%} w-[40%] lg:px-0 px-3 py-4 text-center sm:whitespace-normal whitespace-nowrap justify-center bg-[#727272]"
					>
						Subscribe Now <FaArrowRight className="w-10" />
					</button>
				</div>
			</div>
			<div className="flex lg:flex-row flex-col lg:gap-0 mt-12 gap-10 justify-between items-start">
				<div className="lg:w-[35%] w-full text-white">
					<Link to="/home">
						<img src="/footerha.svg" alt="" className="w-40" />
					</Link>
					<div className="flex flex-col items-start gap-8">
						<div className="mt-8 space-y-3">
							<hr className="w-20" />
							<p>You can reach us at :</p>
							<p className="cursor-pointer">
								<a
									href="mailto:support@findmyvenue.com"
									className="text-blue-500 underline"
								>
									support@findmyvenue.com
								</a>
							</p>
						</div>
					</div>
				</div>
				<div className="lg:w-[60%] w-full grid sm:grid-cols-4 grid-cols-2 text-white gap-10">
					<div>
						<h1 className="text-lg font-medium">Users</h1>
						<Link to="/listing/3">
							<p className="mt-2">Explore Venues</p>
						</Link>
						{/* "How it works?" with a Click-to-Open Modal */}
						<p
							className="mt-2 cursor-pointer text-white"
							onClick={() => setShowModal(true)}
						>
							How it works?
						</p>
						<div onClick={handleClickUserLogin} className="cursor-pointer">
							<p className="mt-2">User Login</p>
						</div>
						<div className="mt-2">
							<Link to="/faqs">FAQs</Link>
						</div>
					</div>
					<div>
						<h1 className="text-lg font-medium">Venues</h1>
						<Link to={"/list-venues"}>
							<p className="mt-2">Why list with us?</p>
						</Link>
						<Link to={"/vendor-login"}>
							<p className="mt-2">Vendor Login</p>
						</Link>
						<div className="mt-2">
							<Link to="/faqs">Venue FAQs</Link>
						</div>
					</div>
					<div>
						<h1 className="text-lg font-medium">Findmyvenue</h1>
						<div className="block mt-2">
							<Link to="/about">About Us</Link>
						</div>
						<div className="block mt-2">
							<Link to="/terms&conditions">Terms & Conditions</Link>
						</div>
						<div className="block mt-2">
							<Link to="/privacy-policy">Privacy Policy</Link>
						</div>
						<div className="block mt-2">
							<Link to="/blogs">Blogs</Link>
						</div>
						<div className="block mt-2">
							<Link to="/careers">Careers</Link>
						</div>
						<div className="block mt-2">
							<Link className="block" to={"/contact"}>
								Contact Us
							</Link>
						</div>
					</div>

					<div>
						<h1 className="text-lg font-medium">Follow Us On</h1>
						<div className="flex flex-col gap-3 mt-2 text-white ">
							<Link to="https://www.facebook.com/61566486906523">
								<div className="flex gap-x-3">
									<FaSquareFacebook className="text-xl" />
									Facebook
								</div>
							</Link>
							<Link to="https://www.instagram.com/findmyvenuehq">
								<div className="flex gap-x-3">
									<RiInstagramFill className="text-xl" />
									Instagram
								</div>
							</Link>
							<Link to="https://www.linkedin.com/company/find-my-venue-uae">
								<div className="flex gap-x-3">
									<IoLogoLinkedin className="text-xl" />
									LinkedIn
								</div>
							</Link>
						</div>
					</div>
				</div>
			</div>
			<div className="flex justify-between mt-20 gap-4">
				<p className="text-white font-thin ">
					© 2024 Find My Venue. All rights reserved. |{" "}
					<Link to={"/privacy-policy"}>Privacy</Link> |{" "}
					<Link to={"/terms&conditions"}>T & C</Link> |{" "}
					<Link to={"/cancellation-policy"}>Cancellation Policy</Link>
				</p>
				<div
					onClick={onScrollDownClick}
					className="w-12 h-12 px-2 flex items-center justify-center border cursor-pointer rounded-md text-white"
				>
					<GoArrowUp className="text-white text-xl" size={24} />
				</div>
			</div>
			{showModal && (
				<div className="fixed top-0 left-0 w-full h-full flex items-center justify-center bg-black bg-opacity-50 z-50">
					<div className="bg-white p-6 rounded-lg shadow-lg relative w-[92%] md:w-[58%] lg:w-[65%]">
						<button
							onClick={() => setShowModal(false)}
							className="absolute top-2 right-2 bg-red-500 text-white px-3 py-1 rounded-full"
						>
							✕
						</button>

						{/* Embedded YouTube Video */}
						<iframe
							width="100%"
							height="690"
							src="https://www.youtube.com/embed/eOUZDG8FYgQ?autoplay=1"
							title="How Find My Venue Works"
							frameBorder="0"
							allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
							allowFullScreen
						></iframe>
					</div>
				</div>
			)}
			<Modal
				isOpen={showSignUp}
				onClose={() => {
					dispatch(closeModals());
					dispatch(resetFormData());
				}}
				label="Sign up"
			>
				<SignUpModal
					setShowSignUp={() => {
						navigate("/user-signup");
					}}
					onLoginClick={() => {
						// dispatch(toggleLogin());

						dispatch(resetFormData());
						navigate("/user-login");
					}}
					onSubmit={() => dispatch(toggleCheckInbox())}
					onSocialClick={() => dispatch(toggleSocial())}
				/>
			</Modal>

			<Modal
				isOpen={showLogin}
				onClose={() => {
					dispatch(closeModals());
					dispatch(resetFormData());
				}}
				label="Log in"
			>
				<LoginModal
					onSignUpClick={() => {
						navigate("/user-signup");
					}}
					onSubmit={() => dispatch(closeModals())}
					onSocialClick={() => dispatch(toggleSocial())}
				/>
			</Modal>

			<Modal
				isOpen={showReset}
				onClose={() => dispatch(closeModals())}
				label="Reset Password"
			>
				<ResetPassword
					onSubmit={() => dispatch(closeModals())}
					mail={encryptedMail}
				/>
			</Modal>
			<Modal
				isOpen={updatePassword}
				onClose={() => dispatch(closeModals())}
				// label="Reset Password"
			>
				<PasswordUpdated
					onSubmit={() => dispatch(closeModals())}
					mail={encryptedMail}
				/>
			</Modal>

			<Modal
				isOpen={resetMailSend}
				onClose={() => dispatch(closeModals())}
				// label="Reset Password Email Sent"
			>
				<ResetMailSend onSubmit={() => dispatch(closeModals())} />
			</Modal>

			<Modal
				isOpen={resetWorkMail}
				onClose={() => dispatch(closeModals())}
				label="Reset Password"
			>
				<ResetWorkMail onSubmit={() => dispatch(closeModals())} />
			</Modal>

			<Modal
				isOpen={resetMailSend}
				onClose={() => dispatch(closeModals())}
				// label="Reset Password Email Sent"
			>
				<ResetMailSend onSubmit={() => dispatch(closeModals())} />
			</Modal>

			<Modal
				isOpen={showSocial}
				onClose={() => dispatch(closeModals())}
				label=""
			>
				<SocialModal
					onLoginClick={() => {
						navigate("/user-login");
					}}
					onAdditionalClick={() => dispatch(toggleAdditional())}
				/>
			</Modal>

			<Modal
				isOpen={showAdditional}
				onClose={() => dispatch(closeModals())}
				label="Additional Details"
				isCloseBtnDisable={true}
			>
				<AdditionalDetails onSubmit={() => dispatch(closeModals())} />
			</Modal>

			<Modal
				isOpen={showCheckInbox}
				onClose={() => dispatch(closeModals())}
				label=""
			>
				<CheckInboxModal onClose={() => dispatch(closeModals())} />
			</Modal>
		</div>
	);
};

export default Footer;
